import {Property} from "../../contract/config";

export enum Models {
  ARTICLE = 'article',
  TOPIC = 'topic',
}

export type ModelsDef = {
  [key in Models]: {
    [key: string]: Property;
  }
}

const models: ModelsDef = {
  [Models.ARTICLE]: {
    featuredImage: ['url', 'Featured Image'],
    imageCredit: 'Image Credit',
    introduction: ['rich', 'Introduction Full'],
    introductionShort: ['rich', 'Introduction Short'],
    publishedTime: ['date', 'Publication Date'],
    slug: ['slug', null],
    streamer: 'Streamer',
    streamerAttribution: 'Streamer Attribution',
    callout: 'Callout',
    calloutPosition: ['prop', 'Callout Position'],
    title: 'Title Full',
    titleShort: 'Title Short',
    topics: ['relations', 'Themes'],
  },
  [Models.TOPIC]: {
    title: 'Title',
    slug: ['slug', null],
    articles: ['relations', 'Articles'],
  },
}

export default models;
